import { useAccount } from "@hooks/useAccount";
import { AccountPageLayout } from "../AccountPageLayout";
import { Order } from "./Order";
import { NoOrders } from "./NoOrders";
import { Loading } from "../Loading";
import { Error } from "../Error";
import styles from "./styles/OrderHistory.module.css";

export const OrderHistory = ({ products }) => {
  const { account, isLoading } = useAccount();
  const { error, orders } = account;

  if (error) {
    return (
      <Error
        title="Order History"
        errorMessage={error.message}
      />
    )
  };

  if (isLoading) {
    return <Loading title="Order History" />
  };

  if (!orders.length) {
    return (
      <AccountPageLayout title="You haven't placed any orders yet.">
        <NoOrders products={products} />
      </AccountPageLayout>
    )
  }

  return (
    <AccountPageLayout title="Order History">
      <ul className={styles.list}>
        {orders.map(order => {
          return (
            <li key={order.orderNumber} className={styles.listItem}>
              <Order order={order} />
            </li>
          )
        })}
      </ul>
    </AccountPageLayout>
  )
}
